module.exports = __webpack_public_path__ + "img/lf7.069cc7f8.png";